<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="py-2 mr-6 d-flex align-center">
        <span class="font-weight-bold">{{ cardTitle }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content eager>
      <text-input
        :value="templateOption.template_option"
        :readonly="isDisabled || readonly"
        :disabled="isDisabled || readonly"
        label="Key"
        required
        @change="onInput($event, 'template_option')"
      />

      <v-combobox
        :value="templateOption.options"
        :readonly="readonly"
        :disabled="readonly"
        :items="templateOption.options"
        label="Options"
        outlined
        chips
        multiple
        @input="onInput($event, 'options')"
      />

      <select-list
        :value="templateOption.default_option"
        :items="templateOption.options"
        :disabled="readonly"
        class="mb-4"
        label="Default Option"
        required
        hide-details
        @change="onInput($event, 'default_option')"
      />

      <div class="d-flex align-center justify-space-between">
        <v-btn color="error" depressed :disabled="isDisabled" @click="onDeleteClick">
          <v-icon left>delete</v-icon>
          <span>Remove</span>
        </v-btn>
      </div>
    </v-expansion-panel-content>
    <v-divider />
  </v-expansion-panel>
</template>

<script>
import { capitalize, snakeCase } from 'lodash-es'
import TextInput from '@/components/forms/text-input'
import SelectList from '@/components/forms/select-list'

export default {
  name: 'TemplateOptionBlock',
  components: { TextInput, SelectList },
  props: {
    originalTemplateOptions: {
      type: Array,
      required: true,
    },
    templateOption: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cardTitle() {
      return capitalize(this.templateOption.template_option.replace(/_/gi, ' '))
    },
    isDisabled() {
      return this.originalTemplateOptions.some(
        ({ template_option }) => template_option === this.templateOption.template_option
      )
    },
  },
  methods: {
    onDeleteClick() {
      this.$emit('delete')
    },
    onInput(value, model) {
      if (model === 'template_option') value = snakeCase(value.trim())
      this.$emit('input', { ...this.templateOption, [model]: value })
    },
  },
}
</script>
